import { Component } from "react";
import { RefreshCw } from "lucide-react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            background: "#050505",
            color: "#fff",
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
          data-testid="error-boundary"
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 16,
              background: "rgba(239,68,68,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 24,
            }}
          >
            <RefreshCw style={{ width: 28, height: 28, color: "#ef4444" }} />
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
            Algo deu errado
          </h1>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginBottom: 16, maxWidth: 320 }}>
            Ocorreu um erro inesperado. Tente recarregar a pagina.
          </p>
          {this.state.error && (
            <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginBottom: 24, maxWidth: 500, wordBreak: "break-all", padding: "8px 12px", background: "rgba(255,255,255,0.05)", borderRadius: 8 }}>
              Erro: {this.state.error.message || String(this.state.error)}
            </p>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              borderRadius: 12,
              background: "#6366f1",
              color: "#fff",
              border: "none",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Recarregar pagina
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
